import { useLabels } from 'labels/hooks/useLabels/useLabels'
import replacePlaceholders from 'labels/lib/replacePlaceholders'
import { Pricing } from 'my-purchases/components/Pricing/Pricing'
import { cx } from 'utils/cx'

import style from './ArticlePrice.module.scss'

interface ArticlePrice {
	price: string
	additionalPrices?: string[]
}

export interface ArticlePrices {
	originalPrice: ArticlePrice
	discountedPrice?: ArticlePrice
}

export function ArticlePrice({
	'data-testid': dataTestId,
	prices: { originalPrice, discountedPrice },
}: {
	readonly 'data-testid'?: string
	readonly prices: ArticlePrices
}) {
	const { t } = useLabels()

	return (
		<div>
			<Pricing
				screenReaderLabel={replacePlaceholders(
					t(
						discountedPrice
							? 'accessibility.prices.firstPrice.variable'
							: 'accessibility.prices.currentPrice.variable'
					),
					{
						1: originalPrice.price,
					}
				)}
				price={originalPrice.price}
				additionalPrices={originalPrice.additionalPrices}
				className={cx(discountedPrice && style.discountedPrice)}
				{...(dataTestId && {
					'data-testid': `${dataTestId}.price`,
				})}
			/>
			{discountedPrice && (
				<Pricing
					screenReaderLabel={replacePlaceholders(
						t('accessibility.prices.currentPrice.variable'),
						{
							1: discountedPrice.price,
						}
					)}
					price={discountedPrice.price}
					additionalPrices={discountedPrice.additionalPrices}
					hasDiscount={!!discountedPrice}
					{...(dataTestId && {
						'data-testid': `${dataTestId}.discountedPrice`,
					})}
				/>
			)}
		</div>
	)
}
